var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMorehoriz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_532_3512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 10C5.65 10 4.75 10.9 4.75 12C4.75 13.1 5.65 14 6.75 14C7.85 14 8.75 13.1 8.75 12C8.75 10.9 7.85 10 6.75 10ZM18.75 10C17.65 10 16.75 10.9 16.75 12C16.75 13.1 17.65 14 18.75 14C19.85 14 20.75 13.1 20.75 12C20.75 10.9 19.85 10 18.75 10ZM12.75 10C11.65 10 10.75 10.9 10.75 12C10.75 13.1 11.65 14 12.75 14C13.85 14 14.75 13.1 14.75 12C14.75 10.9 13.85 10 12.75 10Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_532_3512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorehoriz);
export default __webpack_public_path__ + "static/media/Morehoriz.cb55ead4228078b66c387554f91a0004.svg";
export { ForwardRef as ReactComponent };